module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABCSURBVHgB7ZKxCQAwCAQ/IYNk/6XiJh8C9gpKCvHA7jgsHjAged4hChXLm0iiQx9DQzeyEUPSPjLpQVYOLYcjDgcXErUdhNcD73UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/ico_plus.png
// module id = JFNY
// module chunks = 0